import React from 'react';
import Reveal from 'react-awesome-reveal';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import OwlCarousel from '../../features/owl-carousel';
import ALink from '../../common/ALink';

import { fadeIn } from '../../../utils/data/keyframes';
import { solutionsSlider } from '../../../utils/data/slider';
import useTranslation from '../../../utils/hooks/useTranslation';

export default function SolutionsSection({ loading, solution }) {
    const { t } = useTranslation();

    return (
        <section className="solutions-section-modern">
            <div className="container">
                <div className="section-header">
                    <span className="section-eyebrow">{t('message.industries_we_serve')}</span>
                    <h2>{t('label.solutions')}</h2>
                    <p className="section-subtitle">{t('message.solutions_subtitle')}</p>
                </div>

                <OwlCarousel adClass="solutions-slider-modern modern-slider owl-theme" options={solutionsSlider}>
                    {loading
                        ? [0, 1, 2].map((item, index) => (
                            <div className="skel-pro skel-pro-grid" key={`solution-skel-${index}`} />
                        ))
                        : solution?.map((item, index) => (
                            <Reveal
                                keyframes={fadeIn}
                                delay={100}
                                duration={800}
                                triggerOnce
                                key={`solution-${item.id}`}
                            >
                                <div className="solution-card">
                                    <ALink href={`/solutions/${item.list[0].slug}`}>
                                        <figure>
                                            <LazyLoadImage
                                                alt={t(item.title)}
                                                src={process.env.REACT_APP_PUBLIC_ASSET_URI + item.images[0].url}
                                                threshold={500}
                                                width="100%"
                                                height="100%"
                                                effect="opacity"
                                            />
                                        </figure>
                                        <span className="solution-overlay" />
                                        <div className="solution-card-body">
                                            <div className="solution-card-title">
                                                <h3>{t(item.title)}</h3>
                                                <span className="solution-cta">
                                                    {t('message.learn_more')}
                                                    <i className="icon-angle-right" />
                                                </span>
                                            </div>
                                            <span className="solution-arrow" aria-hidden="true">
                                                <i className="icon-angle-right" />
                                            </span>
                                        </div>
                                    </ALink>
                                </div>
                            </Reveal>
                        ))}
                </OwlCarousel>
            </div>
        </section>
    );
}
